import {Languages} from "lucide-react";
import {SUPPORTED_LANGUAGES} from "./language";
import {useAdminLanguage, useTranslation} from "./index";

// Переключатель языка стоит в шапке рядом с выбором страны и повторяет его
// разметку: та же обёртка, тот же select, та же подпись через aria-label.
export const LanguageSelect = () => {
    const {t} = useTranslation();
    const [language, changeLanguage] = useAdminLanguage();

    return (
        <label className="admin-country-scope">
            <Languages size={14} />
            <select
                className="admin-country-select"
                value={language}
                onChange={(event) => changeLanguage(event.target.value)}
                aria-label={t("language.ariaLabel")}
            >
                {SUPPORTED_LANGUAGES.map((code) => (
                    <option key={code} value={code}>
                        {t(`language.options.${code}`)}
                    </option>
                ))}
            </select>
        </label>
    );
};
